import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-top-nav-login',
    templateUrl: './top-nav-login.component.html',
    styleUrls: ['./top-nav-login.component.scss'],
    standalone: false
})

export class TopNavLoginComponent {
  @Input() bbApp:boolean=true;
  applicationRoles:any[]=[];
  selectedRole:number=1;
constructor(private _userserivce:UserService,private route:ActivatedRoute,private langservice:LanguageService){}


 setLanguage(lang:string) {
  
 this.langservice.setCurrentLang(lang);
}

}
